import React, { useState, useEffect, useCallback } from 'react';
import SimulatorFilters from './SimulatorFilters';
import SimulatorResult from './SimulatorResult';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { initAssetData } from 'features/asset/hierarchy/actionCreators';
import { bindActionCreators } from 'redux';
import { loadSimulatorAssets, resetSimulatorAssets } from '../../actionCreators';
import { downloadAssetImage } from 'features/asset/image/actionCreators';
import { getAssetImage } from 'features/asset/hierarchy/selectors';
import { defaultPager } from '../../constants';
import { PickerWrapper } from '../../SimulatorStyles';

const SimulatorAssetSelectionContainer = ({
  actions,
  assetTypes,
  filterValues,
  assets,
  savingOffer,
  onAssetSelected,
  onSliderPropertyChange,
  images
}) => {
  const { loading, data } = assets;
  const [pager, setPager] = useState({ ...defaultPager });
  const [pageChanged, setPageChanged] = useState(false);

  useEffect(() => {
    data && data.filter(x => x.assetHierarchyId && !x.imageUrl).map(x => actions.downloadAssetImage(x.assetHierarchyId));
  }, [actions, data]);

  const handleLoadSimulatorAssets = useCallback(() => {
    actions.loadSimulatorAssets(filterValues, pager);
    setPageChanged(false);
  }, [actions, filterValues, pager]);

  const loadAssetImage = useCallback(
    assetHierarchyId => {
      return getAssetImage(assetHierarchyId, images);
    },
    [images]
  );

  const handlePageChange = useCallback(
    page => {
      if (loading) return;
      setPager({ ...pager, page });
      setPageChanged(true);
    },
    [loading, pager]
  );

  useEffect(() => {
    pageChanged && handleLoadSimulatorAssets();
  }, [handleLoadSimulatorAssets, pageChanged]);

  const handleRefresh = useCallback(() => {
    handleLoadSimulatorAssets();
  }, [handleLoadSimulatorAssets]);

  return (
    <PickerWrapper container spacing={2}>
      <SimulatorFilters
        assetTypes={assetTypes}
        filterValues={filterValues}
        handleFiltersChange={onSliderPropertyChange}
        onLoadSimulatorAssets={handleLoadSimulatorAssets}
        assetsLoading={loading}
      />
      <SimulatorResult
        assets={assets}
        loadAssetImage={loadAssetImage}
        images={images}
        pager={pager}
        onRefresh={handleRefresh}
        onChangePage={handlePageChange}
        onAssetSelected={onAssetSelected}
        savingOffer={savingOffer}
        filterValues={filterValues}
        handleFiltersChange={onSliderPropertyChange}
      />
    </PickerWrapper>
  );
};

SimulatorAssetSelectionContainer.propTypes = {
  assetTypes: PropTypes.array.isRequired,
  filterValues: PropTypes.object.isRequired,
  assets: PropTypes.object.isRequired,
  assetInfo: PropTypes.object,
  images: PropTypes.object,
  actions: PropTypes.object.isRequired,
  savingOffer: PropTypes.bool.isRequired,
  onAssetSelected: PropTypes.func.isRequired,
  onSliderPropertyChange: PropTypes.func.isRequired
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        initAssetData,
        loadSimulatorAssets,
        downloadAssetImage,
        resetSimulatorAssets
      },
      dispatch
    )
  };
}

function mapStateToProps(state) {
  const assetTypes = state.assetData.assetTypes;
  const images = state.assetData.images;

  return {
    assetTypes,
    images
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SimulatorAssetSelectionContainer);
